<template>
  <div class="line-box">
    <div id="center-line-chart"></div>
    <dv-decoration-10 class="decoration-line" style="width: 100%; height: 3px" />
    <dv-decoration-4 class="decoration-line" style="width: 3px; height: 100%" />
  </div>
</template>

<script>
import { getDailyTradingVolume } from '../../../api/colunm3'
import option from '../js/lineChart copy'
export default {
  data () {
    return {
      xData: null,
      option: option,
      Chart: null,
      timer: null
    }
  },

  created () {
    this.option.series[0].itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(103, 224, 227, .6)'
    }, {
      offset: 1,
      color: 'rgba(103, 224, 227, .1)'
    }])
    this.option.series[1].areaStyle.normal.color = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(251, 114, 147, 1)'
      }, {
        offset: 1,
        color: 'rgba(251, 114, 147, 0)'
      }
    ], false)
    this.getData()
    // setTimeout(() => {
    //   this.option.series[0].data[2] = 25000
    //   this.myEcharts()
    // }, 1000 * 5)
  },

  mounted() {
    this.myEcharts()
    var app = {
      currentIndex: -1,
    }
    setInterval( () => {
      var dataLen = this.option.series[0].data.length;
      // 取消之前高亮的图形
      this.Chart.dispatchAction({
        type: 'downplay',
        seriesIndex: 0,
        dataIndex: app.currentIndex
      })
      app.currentIndex = (app.currentIndex + 1) % dataLen;
      //console.log(app.currentIndex);
      // 高亮当前图形
      this.Chart.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex: app.currentIndex,
      })
      // 显示 tooltip
      this.Chart.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: app.currentIndex
      });
    }, 1000 * 10);
  },

  methods: {
    getData () {
      getDailyTradingVolume().then(res => {
        const data = res.dates.map(element => {
          return element.substring(0, 10)
        })
        this.option.xAxis.data = data
        this.option.series[0].data = res.aTurnovers
        this.option.series[1].data = res.ordersNumbers
        this.myEcharts()
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getGx, 1000 * 10)
      })
    },

    myEcharts () {
      if (this.Chart) {
        this.Chart.setOption(this.option)
      } else {
        this.Chart = this.$echarts.init(document.getElementById("center-line-chart"))
        this.Chart.setOption(this.option)
      }
    }
    // get_30_day() {
    //   var thrityMonth = [];
    //   for (let i = 0; i < 30; i++) {
    //     let temp = new Date(
    //       new Date().setDate(new Date().getDate() - i)
    //     ).toLocaleDateString();
    //     temp = temp.split("/");
    //     temp = temp[1] + "月" + temp[2] + "日";
    //     thrityMonth.unshift(temp);
    //   }
    //   this.xData = thrityMonth;
    // },
  }
}
</script>

<style lang="less" scoped>
.line-box {
  position: relative;
  width: 648px;
  height: 301px;
  background: linear-gradient(-21deg, rgba(14, 49, 115, 0.5), rgba(7, 20, 73, 0.5));
  #center-line-chart {
    width: 100%;
    height: 100%;
  }
  .decoration-line:nth-child(2) {
    z-index: 99;
    position: absolute;
    top: 0;
    left: 0;
  }
  .decoration-line:nth-child(3) {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>